export default __webpack_public_path__ + "static/media/27.cfa3ae4b.mp3";